import { Card, ControlledInput, DataTable, cn } from "@dune/ui";
import { FileWarning } from "lucide-react";
import { Control, UseFormWatch } from "react-hook-form";
import { categoriesColumns } from "../../../../auth/register/register-second-step-broker/categoriesColumns";
import { PartnershipRequestAnalysisFormData } from "../usePartnershipRequestAnalysis";
import AddressFormFields from "../../../../component/shared/AddressFormFields";

interface SocietySectionProps {
	control: Control<PartnershipRequestAnalysisFormData>;
	watch: UseFormWatch<PartnershipRequestAnalysisFormData>;
	isPanelOpen: boolean;
}

export const SocietySection = ({
	control,
	watch,
	isPanelOpen,
}: SocietySectionProps) => {
	return (
		<div className={cn("flex flex-col gap-4 pb-3", !isPanelOpen && "xl:w-2/3")}>
			<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
				<div
					className={cn("flex flex-col gap-4", !isPanelOpen && "md:flex-row")}
				>
					<ControlledInput
						label="Numéro ORIAS"
						control={control}
						name="oriasNumber"
					/>
					<ControlledInput label="SIREN" control={control} name="siren" />
				</div>
				<ControlledInput
					label="Dénomination"
					control={control}
					name="denomination"
				/>
				<div className="text-text-secondary-blue">Adresse du siège social</div>
				<AddressFormFields
					fieldPrefix="headquartersAddress"
					showBorder={false}
				/>
				<div className="text-text-secondary-blue">Catégories</div>
				<DataTable
					columns={categoriesColumns}
					data={watch("categories")}
					noResultsText="Aucune catégorie trouvée"
					icon={FileWarning}
					variant="gray-no-pagination"
				/>
			</Card>
		</div>
	);
};
